import React, { useEffect, useState } from 'react'
import List from '../../../Component/Applications/List/suggested'
import { Link, useHistory, useLocation, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { toast } from 'react-toastify';
import Loader from '../../../Component/Common/Loader';
import constant from '../../../constant';
import styles from './style.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faChevronDown, faLocationDot, faPencil } from '@fortawesome/free-solid-svg-icons';
import { evaluateProfiles, suggestedProfiles, UpdateJobResponse } from '../../../action/jobs';
import { setsessionStorage } from '../../../utils';
const Index = ({ activeTab, setActiveTab }) => {
    const history = useHistory();
    const [showLoader, setShowLoader] = useState(false)
    const [showDetail, setShowDetail] = useState(false)

    const [refresh, setRefresh] = useState(false)

    const [currentPage, setCurrentPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [data, setData] = useState(null)
    const params = useParams()
    const fetchsuggestedProfiles = () => {
        setShowLoader(true)

        suggestedProfiles({
            page: currentPage,
            limit: limit,
            job_id: params.job_id
        }).then((res) => {
            if (res.status) {
                if (res.result.count == 0) {
                    onStartEvaluating()
                }
                setData(res.result)
            }
            else {
                toast.error(res.error)
            }
        }).finally(() => {
            setShowLoader(false)
        })
    }
    useEffect(() => {

        fetchsuggestedProfiles()
    }, [currentPage, limit, refresh])

    const onStartEvaluating = () => {
        setShowLoader(true)
        evaluateProfiles(params.job_id).then((res) => {
            if (res.status) {
                setRefresh(!refresh)
                // toast.success(res.result.message)
            }
        }).finally(() => {
            setShowLoader(false)

        })
    }
    return (
        <React.Fragment>
            {showLoader && <Loader />}
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h6 className={`${styles['text-comm']}`}><FontAwesomeIcon icon={faArrowLeft} className='pe-1'
                                onClick={() => {
                                    history.push(constant.component.dashboard.url)
                                }}
                            />{data?.count} profiles found for <strong>{data ? data.jobDetail.JOB_TITLE : ''}</strong><a className={`${styles['text-link']} ps-2`} href='javascript:void(0);'
                                onClick={() => {
                                    setShowDetail(!showDetail)
                                }}
                            >{showDetail ? 'Hide details' : 'View details'}<FontAwesomeIcon className='ps-2' icon={faChevronDown} /></a></h6>
                            <div className={`${styles['text-comm']} border-start border-end px-3 text-center`}>
                                <FontAwesomeIcon className='pe-2' icon={faLocationDot} />{data?.jobDetail?.CITIES?.join((', '))}
                            </div>
                            {/* <div className={`${styles['text-comm']} border-end text-center px-3`}>
                                Previous:<strong>Premium</strong>
                            </div> */}
                            <div>
                                <Link to={
                                    constant.component.postOppurtunity.url
                                }
                                    onClick={() => {
                                        setsessionStorage(constant.keys.jobPostingSession, { step: 2, id: params.job_id })
                                    }} className={`${styles['edit-btn']} btn`}><FontAwesomeIcon icon={faPencil} className='pe-1' />Edit</Link>
                            </div>
                        </div>
                        {showDetail && <div>

                            <h5 className={`${styles['ct-title']}`}>Showing Result for</h5>

                            {/* Keywords Section */}
                            <div className="my-3">
                                <h6 className={`${styles['pt-title']} mb-2`}>Keywords</h6>
                                <div className="d-flex flex-wrap gap-2">
                                    {[
                                        "HR Recruiter",
                                        "Human Resource Recruiter",
                                        "Senior HR Recruiter",
                                        "HR Associate",
                                        "HR Professional",
                                        "Human Resource Intern",
                                        "Junior HR Executive",
                                        "Talent Acquisition Specialist",
                                        "Recruitment Consultant",
                                    ].map((keyword, index) => (
                                        <span key={index} className={`${styles['ct-badge']}`}>
                                            {keyword} <span className="ms-1">&times;</span>
                                        </span>
                                    ))}
                                </div>
                            </div>

                            {/* City Section */}
                            <div className="mb-3">
                                <h6 className={`${styles['pt-title']} mb-2`}>City</h6>
                                <span className={`${styles['ct-badge']}`}>
                                    Bangalore <span className="ms-1">&times;</span>
                                </span>
                            </div>

                            {/* Experience Section */}
                            <div className="mb-3">
                                <h6 className={`${styles['pt-title']} mb-2`}>Experience</h6>
                                <span className={`${styles['ct-badge']}`}>
                                    2 Years <span className="ms-1">&times;</span>
                                </span>
                            </div>

                        </div>
                        }
                        <ul className="nav nav-justified nav-tabs mb-3 border-0">
                            <li className="nav-job nav-item">
                                <button
                                    className={`nav-link ${activeTab === "Applied Jobs" ? "active" : ""}`}
                                    onClick={() => {
                                        debugger;
                                        setActiveTab("Applied Jobs")
                                    }}
                                >
                                    Applied Jobs
                                </button>
                            </li>
                            <li className="nav-job nav-item">
                                <button
                                    className={`nav-link ${activeTab === "Suggested Candidates" ? "active" : ""}`}
                                    onClick={() => setActiveTab("Suggested Candidates")}
                                >
                                    Suggested Candidates
                                </button>
                            </li>
                        </ul>
                        <div className="row">
                            {<List
                                onStartEvaluating={onStartEvaluating}
                                limit={limit}
                                setLimit={setLimit}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                data={data}
                            />}
                        </div>
                    </div>
                </div>
            </div >
        </React.Fragment>
    )
}

export default Index